/**
 * Mopper · Pages villes SEO — SOURCE DE VÉRITÉ UNIQUE.
 *
 * Les données des 23 villes vivent désormais dans `src/data/cities.data.json`,
 * consommé À LA FOIS par ce module (runtime React) et par
 * `scripts/cities_data.py` (génération des snapshots + sitemap).
 * → Un seul jeu de données : snapshot, runtime et sitemap produisent exactement
 *   les mêmes URLs indexables, avec parité URL par URL du qualityScore,
 *   des robots et des canonical.
 *
 * Ne pas dupliquer ces données ailleurs. Toute modification se fait dans le JSON.
 */
import citiesJson from "@/data/cities.data.json";

export const CITIES = citiesJson;

// Ordered slug list for footer / sitemap / navigation.
export const CITY_SLUGS = CITIES.map((c) => c.slug);

// Lookup by slug (used in CityPage.jsx).
export function getCityBySlug(slug) {
  return CITIES.find((c) => c.slug === slug) || null;
}
